<template>
  <Banner
    v-if="showConsent"
    class="cookie-consent"
    :fixed="true"
    :dark="true"
  >
    <div class="cookie-consent__body">
      <h3>{{ localizedText.title }}</h3>
      <p>{{ localizedText.description }} <nuxt-link :to="{ path }">{{ localizedText.link }}</nuxt-link></p>
    </div>
    <div class="cookie-consent__actions">
      <ShButton @click="handleReject">{{ localizedText.reject }}</ShButton>
      <ShButton color="secondary" @click="handleAccept">{{ localizedText.accept }}</ShButton>
    </div>
  </Banner>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { isUndefined } from 'util'
import { Banner } from '@sohohouse/design-system'

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('cookie_consent')

export default {
  components: {
    Banner
  },

  data () {
    return {
      cookieConsent: null
    }
  },

  watch: {
    cookieConsent (consent) {
      this.$cookies.set('cookie_consent', consent, { path: '/' })
      this.$cookies.expireCookies(consent)
      this.setCookieConsent(consent)
    }
  },

  computed: {
    ...mapState(['path']),
    ...mapGetters(['localizedText']),

    showConsent () {
      return isUndefined(this.$cookies.get('cookie_consent')) && this.cookieConsent === null
    }
  },

  methods: {
    ...mapActions(['setCookieConsent']),

    handleAccept () {
      this.cookieConsent = true
    },

    handleReject () {
      this.$cookies.removeAll()
      this.cookieConsent = false
    }
  }
}
</script>

<style lang="scss">
// Set these incase the variables don't exist from @sohohouse/design-system
$color-black: #000000 !default;
$color-white: #FFFFFF !default;
$space-040: 12px !default;

.cookie-consent {
  h3, p, a {
    color: $color-white;
  }

  &__body {
    width: auto;
  }

  &__actions {
    width: max-content;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 0;
    margin-top: $space-040;

    @include tablet {
      margin-top: 0;
      margin-left: auto;
      justify-content: flex-end;
    }
  }
}
</style>
